import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import { connect } from "react-redux";
import { IconButton } from "@material-ui/core";
import childResInfoImage from "../../../images/childResidenceInfo.png"
import { getAllData, putChildResidence, putChildAge, deleteChildCall } from "../childInformation/ChildInformationAction";
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Collapse,
  CustomInput,
  Card,
  ModalBody,
  Modal,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { isEmpty, isNumber, remove, omit, filter, forEach, size, isNull, isUndefined, map, find, get} from "lodash";
import moment from 'moment';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));




function getSteps() {
  return [
    'Children under the age of 18',
    'Child Address'];
}
function getChildSteps(props) {
  //Make Array from child Details
  let z = [];
  forEach(props.underAge18.yes.childInfo, x => {
    z.push(`${x.first_name} Details`)
  })
  return isEmpty(props.underAge18.yes.childInfo) ? [] : z 
}




function VerticalLinearStepper(props) {
  let ResidenceChildOne = !isEmpty(props.addressConfidential.yes.sameResidence) && size(props.addressConfidential.yes.sameResidence.find(x => x == "1"));
  let ResidenceChildTwo = !isEmpty(props.addressConfidential.yes.sameResidence) && size(props.addressConfidential.yes.sameResidence.find(x => x == "2"));
  let ResidenceChildThree = !isEmpty(props.addressConfidential.yes.sameResidence) && size(props.addressConfidential.yes.sameResidence.find(x => x == "3"));
  

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [div1, setDiv1] = React.useState(!ResidenceChildOne);
  const [div2, setDiv2] = React.useState(!ResidenceChildTwo);
  const [div3, setDiv3] = React.useState(!ResidenceChildThree);
  const [activeStepChild, setActiveStepChild] = React.useState(0);
  const [MoreChildrens, setMoreChildrens] = useState(props.moreThanChildren == "1" ? 1 : "");
  const [inputFields, setInputField] = useState(isEmpty(props.underAge18.yes.childInfo) ? [{ first_name: "", last_name: "", dob: "", childern_age: 0, place_birth: "San Jose, CA", sex: 0 }] : props.underAge18.yes.childInfo);

  const [haveChildrens, setHaveChildrens] = useState(props.underAge18.no.underAge18Status == "1" ? 1 : -1);
  const [confidentialAdress, setConfidentialAdress] = useState(false);
  const [signVDOP, setSignVDOP] = useState("0");
  const [dataObject, setDataObject] = useState([]);
  const [childDetails1, setChildDetails1] = useState({});
  const [childDetails2, setChildDetails2] = useState({});
  const [childDetails3, setChildDetails3] = useState({});
  const [childDetails4, setChildDetails4] = useState({});
  const [BoxesSameResidence, setBoxesSameResidence] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  
  
  const toggleModal = () => setModalOpen(!modalOpen);


  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const steps = getSteps();
  const childSteps = getChildSteps(props);

  const handleChangeInput = (index, e) => {
    const { id, value } = e.target;
    const updatedFields = [...inputFields];
    updatedFields[index] = {
      ...updatedFields[index],
      [id]: value
    };
    setInputField(updatedFields);
  };

  const saveChildResDetails = () => {
    let z=[];
    !isEmpty(childDetails1) && z.push(childDetails1);
    !isEmpty(childDetails2) && z.push(childDetails2);
    !isEmpty(childDetails3) && z.push(childDetails3);
    !isEmpty(childDetails4) && z.push(childDetails4);


  props.putChildResidence({
    addressCondidentialUnknown:  document.getElementById("confidentialAdress").value,
    sameResidence: BoxesSameResidence,
    divorce_id:window.localStorage.getItem("divorce_id"),
    childDetails: z
   })
  }
  const handleAddFields = (index) => {
    setInputField([
      ...inputFields,
      { first_name: "", last_name: "", dob: "", childern_age: 0, place_birth: "San Jose, CA", sex: 0 },
    ]);
  };
  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputField(values);
  };  

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        borderTop: "2px solid",
        color: "black",
      }}
    />
  );

  const ColoredLineSimple = ({ color }) => (
    <hr
      style={{
        borderTop: "1px dashed",
        color: "black",
      }}
    />
  );

  const arrayCB =()=>{
    let cb = [];

    forEach([1, 2, 3], (y) => {
      let z = !isEmpty(props.addressConfidential.yes.sameResidence) && (props.addressConfidential.yes.sameResidence).includes(`${y}`)
      z == true && cb.push(z==true? `${y}` : "");
    });
    setBoxesSameResidence(cb)
  }

  console.log(props.underAge18.yes.unbornChildrenStatus, "status")

  function boxesSameResidence(value) {
    if (BoxesSameResidence.includes(value)) {
        let dummyArray1 = BoxesSameResidence;
        remove(dummyArray1, function (val) {
            return val === value;
        });
    } else {
        let dummyArray1 = BoxesSameResidence;
        dummyArray1.push(value);
        setBoxesSameResidence(dummyArray1);
    }
}


    useEffect(() => {
    props.getAllData({
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
      arrayCB();
   
  }, []);


  const clean_child_data = (data) => {
    if(!isEmpty(data)){
      return data.filter((item)=>
        item.first_name != "" && item.first_name != null && 
        item.last_name != "" && item.last_name != null && 
        item.childern_age != "" && item.childern_age != null &&
        item.dob != "" && item.dob != null && item.asset_date_acquired != "1947-01-01" 
      );
    }
  }

  const handlePostFunc = async () => {

    if (activeStep === 0) {
      await props.putChildAge({
        divorce_id: window.localStorage.getItem("divorce_id"),
        childUnder18: Number(document.getElementById("childern").value),
        moreThanChildren: Number(document.getElementById("childernMore").value),
        signVDOP: document.getElementById("childern").value == 1 ? Number(document.getElementById("signVDOP").value) : "-1",
        unbornChildren: document.getElementById("childern").value == 1 ? Number(document.getElementById("unbornChildren").value) : "",
        data: document.getElementById("childern").value == 1 ? clean_child_data(inputFields).map(v => ({
          ...v,
          children_id: v.children_id,
          divorce_id: window.localStorage.getItem("divorce_id"),
        })) : ""
      });
    }
  }

 let childLive1 = get(props.addressConfidential, 'yes.childDetails[0].child_live_cond');
 let childAddress1 = get(props.addressConfidential, 'yes.childDetails[0].confidential');

 let childLive2 = get(props.addressConfidential, 'yes.childDetails[1].child_live_cond');
 let childAddress2 = get(props.addressConfidential, 'yes.childDetails[1].confidential');

 let childLive3 = get(props.addressConfidential, 'yes.childDetails[2].child_live_cond');
 let childAddress3 = get(props.addressConfidential, 'yes.childDetails[2].confidential');

 let childLive4 = get(props.addressConfidential, 'yes.childDetails[3].child_live_cond');
 let childAddress4 = get(props.addressConfidential, 'yes.childDetails[3].confidential');
 
 const deleteCall = (index) => {
  setActiveStepChild(0);
  if(index == 0) {
    setChildDetails1({});
  } else if(index == 1) {
    setChildDetails2({});
  } else if(index == 2) {
    setChildDetails3({});
  } else if(index == 3) {
    setChildDetails4({});
  }
  props.deleteChildCall({
    children_id : props.underAge18.yes.childInfo != "" && get(props.underAge18.yes.childInfo, `${index}.children_id`, ""),
    divorce_id: window.localStorage.getItem("divorce_id"),
  })
}

const invalidCondition = (value) => {
  if(inputFields.length === 1 && inputFields[0].first_name == "" && inputFields[0].last_name == "" && (inputFields[0].dob == "" || inputFields[0].dob == "1947-01-01") && (inputFields[0].childern_age == "" || inputFields[0].childern_age == 0) ){
    return false;
  } else if(inputFields.length > 0 && (value == "" || value == "0")){
    return true;
  }
  return false;
}

const handleRest = (index) => {
  const values = [...inputFields];
  values[index].first_name = "";
  values[index].last_name = "";
  values[index].dob = "";
  values[index].childern_age = 0;
  values[index].place_birth = "San Jose, CA";
  values[index].sex = 0;
  setInputField(values);
}

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <div>
          
          <FormGroup style={{marginTop:"10px"}}>
            <Label for="childern">
              <h5>
                Do you and your spouse have any children under the age of
                18?
              </h5>
            </Label>
            <Input
              defaultValue={props.underAge18.no.underAge18Status}
              type="select"
              name="childern"
              id="childern"
              onChange={(e) => setHaveChildrens(JSON.parse(e.target.value))}
            >
              <option selected value="-1">
                {" "}
                -- select an option --{" "}
              </option>

              <option value="0" selected={props.underAge18.no.underAge18Status == "0"}>No</option>
              <option value="1" selected={props.underAge18.no.underAge18Status == "1"}>Yes</option>
            </Input>
          </FormGroup>

          <Collapse isOpen={haveChildrens == "1"}>
          <FormGroup>
            <Label for="childernMore">
              <h5>
                Do you have more than 4 children?
              </h5>
            </Label>
            <Input
              defaultValue={props.moreThanChildren}
              type="select"
              name="childernMore"
              id="childernMore"
              onChange={(e) => setMoreChildrens(JSON.parse(e.target.value))}
            >
              <option selected value="-1">
                {" "}
                -- select an option --{" "}
              </option>

              <option value="0" slectecd={props.moreThanChildren == 0}>No</option>
              <option value="1" slectecd={props.moreThanChildren == 1}>Yes</option>
            </Input>
          </FormGroup>

          {(MoreChildrens == '1') &&  <Alert variant="filled" severity="info">
            Notice: Please attach a separate sheet to your Petition (FL-100) or
            Response (FL-120) with each child's name, birth date and age, that is
            your 5th child or greater. Then, complete the FL-105(a), for these children.
          </Alert>}
            <FormGroup style={{marginTop:"10px"}}>
              <Label  for="signVDOP">
                Did either parent sign a voluntary declaration of
                paternity (VDOP) (for child born before marriage)?
              </Label>
              <Input
                defaultValue={props.underAge18.yes.signVDOP.isSignVDOP}
                type="select"
                name="signVDOP"
                id="signVDOP"
                onChange={(e) => setSignVDOP(JSON.parse(e.target.value))}
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
            {!isEmpty(inputFields) && inputFields.map((inputField, index) => (
              <FormGroup key={inputField.children_id || index}>

                {/* Q2 Started */}

                <Row>
                  <Col xl="6" lg="6" md="12" sm="12" xs="12" style={{ marginTop: "20px" }}>
                    <h6>First Name</h6>
                    <Input type="text" id="first_name" invalid={invalidCondition(inputField.first_name)}
                      onChange={(e) => { handleChangeInput(index, e) }}
                    value={inputField.first_name}
                    />
                  </Col>

                  <Col xl="6" lg="6" md="12" sm="12" xs="12" style={{ marginTop: "20px" }}>
                    <h6>Last Name</h6>
                    <Input type="text" id="last_name" invalid={invalidCondition(inputField.last_name)}
                      onChange={(e) => { handleChangeInput(index, e) }}
                    value={inputField.last_name}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xl="4" lg="4" md="6" sm="6" xs="12" style={{ marginTop: "10px" }}>
                    <h6>Date of Birth</h6>
                    <Input type="date" id="dob" invalid={invalidCondition(inputField.dob)}
                      onChange={(e) => { handleChangeInput(index, e) }}
                    value={moment(inputField.dob == "1947-01-01" ? "" : inputField.dob).format('YYYY-MM-DD')}
                    />
                  </Col>

                  <Col xl="2" lg="2" md="6" sm="6" xs="12" style={{ marginTop: "10px" }}>
                    <h6>Age</h6>
                    <Input type="number" id="childern_age" invalid={invalidCondition(inputField.childern_age)}
                      onChange={(e) => { handleChangeInput(index, e) }}
                    value={inputField.childern_age}
                    />
                  </Col>
                  <Col xl="4" lg="4" md="6" sm="6" xs="12" style={{ marginTop: "10px" }}>
                    <h6>Place of Birth</h6>
                    <Input type="text" id="place_birth"
                      onChange={(e) => { handleChangeInput(index, e)}}
                      placeholder="San Jose, CA"
                    value={inputField.place_birth}
                    />
                  </Col>

                  <Col xl="2" lg="2" md="6" sm="6" xs="12" style={{ marginTop: "10px" }}>
                    <h6>Sex</h6>
                    <Input type="select" id="sex"
                      onChange={(e) => { handleChangeInput(index, e) }}
                    value={inputField.sex}

                    >
                      <option disabled>-- select an option --</option>
                      <option value="0">Male</option>
                      <option value="1">Female</option>
                      <option value="2">Other</option>
                      </Input>
                    </Col>
                  </Row>

                <Row>
                  <Col>

                    <IconButton title="Click to Add Next Child"
                      onClick={() => handleAddFields(index)}
                      style={{
                        float: "right",
                        color: "black",
                        marginTop: "15px",
                        pointerEvents: size(inputFields) < 4 ? 'all' : 'none'
                      }}
                    >
                      <AddIcon />
                    </IconButton>

                    {inputFields.length == 1 ? (
                    <IconButton title="Click to Remove Child"
                      onClick={() => {handleRest(index); deleteCall(index);}}
                      style={{ float: "right", color: "black", marginTop: "15px" }}
                    >
                      <RemoveIcon />
                    </IconButton>
                    ):(
                    <IconButton title="Click to Remove Child"
                      onClick={() => {handleRemoveFields(index); deleteCall(index);}}
                      style={{ float: "right", color: "black", marginTop: "15px" }}
                    >
                      <RemoveIcon />
                    </IconButton>)}
                  </Col>
                </Row>

                <ColoredLine />
              </FormGroup>

            ))}

            <FormGroup>
              <Label for="unbornChildren">
                Do you have any unborn children (mother is pregnant)?
              </Label>
              <Input
                defaultValue={props.underAge18.yes.unbornChildrenStatus.isMotherPregnant}
                type="select"
                name="unbornChildren"
                id="unbornChildren"
              >
                <option selected value="-1">
                  {" "}
                  -- select an option --{" "}
                </option>

                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </Collapse>
        </div>
      case 1:
        return (<div>
          <Collapse isOpen={haveChildrens == "1"}>
          <FormGroup>
            <Label for="confidentialAdress">
              <h5>
                Is your address confidential and unknown to the other parent
                because of alleged domestic violence or abuse?
              </h5>
            </Label>
            <Input
              defaultValue={props.addressConfidential.no.addressConfidentialStatus}
              type="select"
              name="confidentialAdress"
              id="confidentialAdress"
              onChange={(e) =>
                setConfidentialAdress(JSON.parse(e.target.value))
              }
            >
              <option selected value="-1"> -- select an option -- </option>

              <option value="0">No</option>
              <option value="1">Yes</option>
            </Input>
          </FormGroup>
          <FormGroup
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              whiteSpace: 'nowrap',
              gap: '4px',
              marginBottom: '8px'
            }}
          >
            <Typography variant="h6" style={{ margin: 0 }}>
              Click
            </Typography>
            <Button
              variant="text"
              size="small"
              onClick={toggleModal}
              style={{
                textTransform: 'none',
                padding: 0,
                minWidth: 'auto',
                fontSize: '1.25rem', // Match h6
                fontWeight: 500,
                lineHeight: 1.5,
              }}
            >
              HERE
            </Button>
            <Typography variant="h6" style={{ margin: 0 }}>
              to get Info on Child Residence Details
            </Typography>
          </FormGroup>
          <Modal isOpen={modalOpen} toggle={toggleModal} style={{ marginTop: "200px", marginLeft: "46%" }}>
            <ModalHeader toggle={toggleModal}>Child Residence Info will be Filled Like this.</ModalHeader>
            <ModalBody style={{ textAlign: "center" }}>
              <img
                src={childResInfoImage}
                alt="Child Residence Info"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </ModalBody>
          </Modal>
          {/* {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <CircularProgress />
            </div>
          ) : ( */}
          <Stepper activeStep={activeStepChild} orientation="vertical">
            {childSteps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography>{getChildStepContent(index)}</Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStepChild === 0}
                        onClick={handleBackChild}
                        className={classes.button}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNextChild}
                        className={classes.button}
                      >
                        {activeStepChild === childSteps.length - 1 ? 'Finish' : 'Next'}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStepChild === childSteps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>All steps completed - you&apos;re finished</Typography>
              <Button onClick={handleResetChild} className={classes.button}>
                Reset
              </Button>
              <Button style={{backgroundColor:"#3f51b5",color:"white"}} onClick={handleBackChild} className={classes.button}>
               Back
          </Button>
            </Paper>
          )}
          </Collapse>
        </div>)
      default:
        return 'Unknown step';
    }
  }

  function getChildStepContent(step) {
    switch (step) {
      case 0:
        return <div>
          <p style={{ marginTop: "10px" }}>You must list where your child has lived for the last five years
           and with whom your child was living. Start with your child's current address and work back 5
           years. Fill in only the number of residences you need to go back 5 years.</p>

          <div style={{ marginTop: "30px" }}>
            <Card body outline color="primary">
              <FormGroup>
                <div>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="dateFrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].datefrom') === "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[0].datefrom')}
                          onChange={(e) => {
                            sessionStorage.setItem("DateFrom", e.target.value);
                          }}
                          type="date"
                          name="from"
                          id="date_from1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={1}>
                    </Col>

                    <Col md={5}>
                      <FormGroup>
                        <Label for="dateTo" style={{marginLeft:"25px"}}>To</Label><br></br>
                        <Label style={{ marginLeft: "60px", marginTop: "7px" }}>Present</Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].child_live', "")}
                          onBlur={(e) => {
                            sessionStorage.setItem("ChildLive", e.target.value);
                          }}
                          type="text"
                          name="child_live_with"
                          id="child_live1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="child_live_cond1"
                          onChange={(e) => {
                            sessionStorage.setItem("ChildLiveConfidential", e.target.checked)
                          }}
                          defaultChecked={childLive1 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label for="relation">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childrelation', "")}
                          onBlur={(e) => {
                            sessionStorage.setItem("Relationship", e.target.value);
                          }}
                          type="text"
                          name="relationship"
                          id="childrelation1"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  
                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                          onBlur={(e) => {
                            sessionStorage.setItem("Address", e.target.value)
                          }}
                          type="text"
                          id="address_child1"
                          placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].address_child', "")}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="confidential1"
                          onChange={(e) => {
                            sessionStorage.setItem("AddressConfidential", e.target.checked)
                          }}
                          defaultChecked={childAddress1 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>
                  </Row>

                  

                  <ColoredLineSimple />

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_from') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_from', "")}
                          type="date"
                          name="from"
                          id="1datefrom1"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_to', "")}
                          type="date"
                          name="to"
                          id="1dateTo1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          type="text"
                          name="child_live_with"
                          id="1child_live_with1"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[0].child_live_with', "") }
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[0].relationship',"") }
                          type="text"
                          name="relationship"
                          id="1relationship1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          type="text"
                          id="1child_address1"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[0].child_address',"")}
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>




                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_from') == "1947-01-01" ? "" : 
                            get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_from',"") }
                          type="date"
                          name="from"
                          id="2datefrom1"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_to') == "1947-01-01" ? "" : 
                            get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_to',"")}
                          type="date"
                          name="to"
                          id="2dateTo1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[1].child_live_with',"") }
                          type="text"
                          name="child_live_with"
                          id="2child_live_with1"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[1].relationship',"")}
                          type="text"
                          name="relationship"
                          id="2relationship1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[1].child_address',"") }
                          type="text"
                          id="2child_address1"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>


                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_from') == "1947-01-01" ? "" : 
                            get(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_from',"")}
                          type="date"
                          name="from"
                          id="3datefrom1"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_to') == "1947-01-01" ? "" : 
                            get(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_to',"")}
                          type="date"
                          name="to"
                          id="3dateTo1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[2].child_live_with',"")  }
                          type="text"
                          name="child_live_with"
                          id="3child_live_with1"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[2].relationship',"") }
                          type="text"
                          name="relationship"
                          id="3relationship1"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[0].childRes[2].child_address',"") }
                          type="text"
                          id="3child_address1"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>

                </div>
              </FormGroup>
            </Card>
          </div>
        </div>
      case 1:
        return <div>
          <Input
            type="checkbox"
            id="checkboxResidence2"
            value="1"
            style={{
              height: "20px",
              width: "20px",
              marginLeft: "6px",
              marginTop: "10px",
            }}
          onChange={(e) => {document.getElementById("checkboxResidence2").checked ? setDiv1(false) : setDiv1(true) ; boxesSameResidence(e.target.value)}}
          defaultChecked={ResidenceChildOne == 1 ? true : false}
          ></Input>
          <Label style={{ marginLeft: "30px", marginTop: "10px" }}>
             Residence is same as enter above.
          </Label>
{div1  &&
          <div style={{ marginTop: "30px" }} id="childOne" hidden={false}>
            <Card body outline color="primary">
              <FormGroup>

                <div>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="dateFrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].datefrom') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[1].datefrom',"")}
                          onChange={(e) => {
                            sessionStorage.setItem("DateFrom", e.target.value);
                          }}
                          type="date"
                          name="from"
                          id="date_from2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={1}>
                    </Col>

                    <Col md={5}>
                      <FormGroup>
                        <Label for="dateTo" style={{marginLeft:"25px"}}>To</Label><br></br>
                        <Label style={{ marginLeft: "60px", marginTop: "7px" }}>Present</Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].child_live',"")}
                          onBlur={(e) => {
                            sessionStorage.setItem("ChildLive", e.target.value);
                          }}
                          type="text"
                          name="child_live_with"
                          id="child_live2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="child_live_cond2"
                          onChange={(e) => {
                            sessionStorage.setItem("ChildLiveConfidential", e.target.checked)
                          }}
                          defaultChecked={childLive2 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label for="relation">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childrelation',"")}
                          onBlur={(e) => {
                            sessionStorage.setItem("Relationship", e.target.value);
                          }}
                          type="text"
                          name="relationship"
                          id="childrelation2"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          onBlur={(e) => {
                            sessionStorage.setItem("Address", e.target.value)
                          }}
                          type="text"
                          id="address_child2"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].address_child',"")}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="confidential2"
                          onChange={(e) => {
                            sessionStorage.setItem("AddressConfidential", e.target.checked)
                          }}
                          defaultChecked={childAddress2 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>
                  </Row>

                  <ColoredLineSimple />

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_from') == "1947-01-01" ? "" :  
                            get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_from',"")}
                          type="date"
                          name="from"
                          id="1datefrom2"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_to',"")}
                          type="date"
                          name="to"
                          id="1dateTo2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          type="text"
                          name="child_live_with"
                          id="1child_live_with2"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_live_with',"") }
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[0].relationship',"") }
                          type="text"
                          name="relationship"
                          id="1relationship2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          type="text"
                          id="1child_address2"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_address',"") }
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>




                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_from') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_from',"")}
                          type="date"
                          name="from"
                          id="2datefrom2"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_to',"")}
                          type="date"
                          name="to"
                          id="2dateTo2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[1].child_live_with',"") }
                          type="text"
                          name="child_live_with"
                          id="2child_live_with2"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[1].relationship',"") }
                          type="text"
                          name="relationship"
                          id="2relationship2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[1].child_address',"") }
                          type="text"
                          id="2child_address2"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>


                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_from') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_from',"")}
                          type="date"
                          name="from"
                          id="3datefrom2"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_to',"")}
                          type="date"
                          name="to"
                          id="3dateTo2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[2].child_live_with',"")  }
                          type="text"
                          name="child_live_with"
                          id="3child_live_with2"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[2].relationship',"") }
                          type="text"
                          name="relationship"
                          id="3relationship2"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[1].childRes[2].child_address',"") }
                          type="text"
                          id="3child_address2"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>

                </div>
              </FormGroup>
            </Card>
          </div>
}
        </div>
      case 2:
        return <div>
          <Input
            type="checkbox"
            id="checkboxResidence3"
            value="2"
            style={{
              height: "20px",
              width: "20px",
              marginLeft: "6px",
              marginTop: "10px",
            }}
            onChange={(e) => {document.getElementById("checkboxResidence3").checked ? setDiv2(false) : setDiv2(true) ; boxesSameResidence(e.target.value)}}
            defaultChecked={ResidenceChildTwo == 1 ? true : false}
          ></Input>
          <Label style={{ marginLeft: "30px", marginTop: "10px" }}>
             Residence is same as enter above.
          </Label>


 { div2 &&        <div style={{ marginTop: "30px" }} id="childTwo" hidden={false}>
            <Card body outline color="primary">
              <FormGroup>

                <div>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="dateFrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].datefrom') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[2].datefrom',"")}
                          onChange={(e) => {
                            sessionStorage.setItem("DateFrom", e.target.value);
                          }}
                          type="date"
                          name="from"
                          id="date_from3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={1}>
                    </Col>

                    <Col md={5}>
                      <FormGroup>
                        <Label for="dateTo" style={{marginLeft:"25px"}}>To</Label><br></br>
                        <Label style={{ marginLeft: "60px", marginTop: "7px" }}>Present</Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].child_live',"")}
                          onBlur={(e) => {
                            sessionStorage.setItem("ChildLive", e.target.value);
                          }}
                          type="text"
                          name="child_live_with"
                          id="child_live3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="child_live_cond3"
                          onChange={(e) => {
                            sessionStorage.setItem("ChildLiveConfidential", e.target.checked)
                          }}
                          defaultChecked={childLive3 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label for="relation">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childrelation',"")}
                          onBlur={(e) => {
                            sessionStorage.setItem("Relationship", e.target.value);
                          }}
                          type="text"
                          name="relationship"
                          id="childrelation3"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          onBlur={(e) => {
                            sessionStorage.setItem("Address", e.target.value)
                          }}
                          type="text"
                          id="address_child3"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].address_child',"")}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="confidential3"
                          onChange={(e) => {
                            sessionStorage.setItem("AddressConfidential", e.target.checked)
                          }}
                          defaultChecked={childAddress3 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>
                  </Row>

                  <ColoredLineSimple />

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_from') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_from',"")}
                          type="date"
                          name="from"
                          id="1datefrom3"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_to',"")}
                          type="date"
                          name="to"
                          id="1dateTo3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          type="text"
                          name="child_live_with"
                          id="1child_live_with3"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_live_with',"")  }
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[0].relationship',"") }
                          type="text"
                          name="relationship"
                          id="1relationship3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          type="text"
                          id="1child_address3"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_address',"")  }
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>




                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_from') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_from',"")}
                          type="date"
                          name="from"
                          id="2datefrom3"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_to',"")}
                          type="date"
                          name="to"
                          id="2dateTo3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[1].child_live_with',"") }
                          type="text"
                          name="child_live_with"
                          id="2child_live_with3"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[1].relationship',"") }
                          type="text"
                          name="relationship"
                          id="2relationship3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[1].child_address',"") }
                          type="text"
                          id="2child_address3"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>


                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_from') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_from',"")}
                          type="date"
                          name="from"
                          id="3datefrom3"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_to',"")}
                          type="date"
                          name="to"
                          id="3dateTo3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[2].child_live_with',"") }
                          type="text"
                          name="child_live_with"
                          id="3child_live_with3"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[2].relationship',"") }
                          type="text"
                          name="relationship"
                          id="3relationship3"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[2].childRes[2].child_address',"") }
                          type="text"
                          id="3child_address3"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>

                </div>
              </FormGroup>
            </Card>
          </div>
    }
        </div>
      case 3:
        return <div>
          <Input
            type="checkbox"
            id="checkboxResidence4"
            value="3"
            style={{
              height: "20px",
              width: "20px",
              marginLeft: "6px",
              marginTop: "10px",
            }}
            onChange={(e) => {document.getElementById("checkboxResidence4").checked ? setDiv3(false) : setDiv3(true) ; boxesSameResidence(e.target.value)}}
            defaultChecked={ResidenceChildThree == 1 ? true : false}
          ></Input>
          <Label style={{ marginLeft: "30px", marginTop: "10px" }}>
             Residence is same as enter above.
          </Label>


  { div3 &&       <div style={{ marginTop: "30px" }} id="childThree" hidden={false}>
            <Card body outline color="primary">
              <FormGroup>

                <div>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="dateFrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].datefrom') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[3].datefrom',"")}
                          onChange={(e) => {
                            sessionStorage.setItem("DateFrom", e.target.value);
                          }}
                          type="date"
                          name="from"
                          id="date_from4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={1}>
                    </Col>

                    <Col md={5}>
                      <FormGroup>
                        <Label for="dateTo" style={{marginLeft:"25px"}}>To</Label><br></br>
                        <Label style={{ marginLeft: "60px", marginTop: "7px" }}>Present</Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].child_live',"")}
                          onBlur={(e) => {
                            sessionStorage.setItem("ChildLive", e.target.value);
                          }}
                          type="text"
                          name="child_live_with"
                          id="child_live4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="child_live_cond4"
                          onChange={(e) => {
                            sessionStorage.setItem("ChildLiveConfidential", e.target.checked)
                          }}
                          defaultChecked={childLive4 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label for="relation">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childrelation',"")}
                          onBlur={(e) => {
                            sessionStorage.setItem("Relationship", e.target.value);
                          }}
                          type="text"
                          name="relationship"
                          id="childrelation4"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          onBlur={(e) => {
                            sessionStorage.setItem("Address", e.target.value)
                          }}
                          type="text"
                          id="address_child4"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].address_child',"")}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Input
                          type="checkbox"
                          id="confidential4"
                          onChange={(e) => {
                            sessionStorage.setItem("AddressConfidential", e.target.checked)
                          }}
                          defaultChecked={childAddress4 == '1' ? true : false}
                          style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "-1px" }} />
                        <h6 style={{ marginLeft: "40px", marginTop: "39px" }}>Confidential</h6>
                      </FormGroup>
                    </Col>
                  </Row>

                  <ColoredLineSimple />

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_from') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_from',"")}
                          type="date"
                          name="from"
                          id="1datefrom4"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_to',"")}
                          type="date"
                          name="to"
                          id="1dateTo4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          type="text"
                          name="child_live_with"
                          id="1child_live_with4"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[0].child_live_with',"")}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[0].relationship',"")}
                          type="text"
                          name="relationship"
                          id="1relationship4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          type="text"
                          id="1child_address4"
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[0].child_address',"")}
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>




                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_from') == "1947-01-01" ? "" :
                          get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_from',"")}
                          type="date"
                          name="from"
                          id="2datefrom4"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_to') == "1947-01-01" ? "" :
                            get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_to',"")}
                          type="date"
                          name="to"
                          id="2dateTo4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[1].child_live_with',"")}
                          type="text"
                          name="child_live_with"
                          id="2child_live_with4"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[1].relationship',"")}
                          type="text"
                          name="relationship"
                          id="2relationship4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[1].child_address',"")}
                          type="text"
                          id="2child_address4"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>


                  <ColoredLineSimple />
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="datefrom">From </Label>
                        <Input
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_from') == "1947-01-01" ? "" :
                          get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_from',"")}
                          type="date"
                          name="from"
                          id="3datefrom4"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="dateTo">To</Label><br></br>

                        <Input
                        defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_to') == "1947-01-01" ? "" :
                          get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_to',"")}
                          type="date"
                          name="to"
                          id="3dateTo4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label>Child lives with</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[2].child_live_with',"")}
                          type="text"
                          name="child_live_with"
                          id="3child_live_with4"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                  <Col md={4}>
                      <FormGroup>
                        <Label for="relationship">Relationship</Label>
                        <Input
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[2].relationship',"")}
                          type="text"
                          name="relationship"
                          id="3relationship4"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      <FormGroup>
                        <Label>Address </Label>
                        <Input
                        placeholder="Enter Complete Address"
                          defaultValue={get(props.addressConfidential, 'yes.childDetails[3].childRes[2].child_address',"")}
                          type="text"
                          id="3child_address4"
                        />
                      </FormGroup>
                    </Col>

                    
                  </Row>

                </div>
              </FormGroup>
            </Card>
          </div>
    }
        </div>
      default:
        return 'Unknown step';
    }
  }

  const areAllChildrenInvalid = () => {
    return inputFields.some(child =>
      child.childern_age == 0 ||
      child.dob == "" ||
      child.first_name == "" ||
      child.last_name == ""
    );
  };
  const conditionOfDisabled = () => {
    if (activeStep === 0){
      const childern = document.getElementById("childern")?.value;
      const childernMore = document.getElementById("childernMore")?.value;
      const signVDOP = document.getElementById("signVDOP")?.value;
      const unbornChildren = document.getElementById("unbornChildren")?.value;
      if(childern == "0") {
        return false;
      }
      if (childern == "-1" || childernMore == "-1" || signVDOP == "-1" || unbornChildren == "-1") {
        return true;
      }
      if(childern == "1" && inputFields.length === 1 && inputFields[0].first_name == "" && inputFields[0].last_name == "" && (inputFields[0].dob == "" || inputFields[0].dob == "1947-01-01") && (inputFields[0].childern_age == "" || inputFields[0].childern_age == 0)){
        return false;
      }
      if(childern == "1" && areAllChildrenInvalid()){
        return true;
      }
    }
    return false;
  }

  const handleNext = async () => {
    await handlePostFunc();
    if (activeStep === 0) {
      setLoading(true);
      try {
        await props.getAllData({
          divorce_id: window.localStorage.getItem("divorce_id"),
        });
        arrayCB(); 
        setActiveStep((prev) => prev + 1);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
     activeStep == "1" && setInputField(isEmpty(props.underAge18.yes.childInfo) ? [{first_name: "", last_name: "", dob: "", childern_age: 0, place_birth: "San Jose, CA", sex: 0 }] : props.underAge18.yes.childInfo);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

 function  handlePostChildFunc (childNumber){    

    let childResidenceArray1 = [];
    let dummyObject = {};
    let x = childNumber;


    if(x == 1) {
      
      // eslint-disable-next-line no-unused-expressions
      dummyObject[`address_child`] = document.getElementById(`address_child${x}`).value,
      dummyObject[`date_from`] = document.getElementById(`date_from${x}`).value,
      dummyObject[`childrelation`] = document.getElementById(`childrelation${x}`).value,
      dummyObject[`confidential`] = document.getElementById(`confidential${x}`).checked == true ? 1 : 0,
      dummyObject[`child_live_cond`] = document.getElementById(`child_live_cond${x}`).checked == true ? 1 : 0,
      dummyObject[`child_live`] = document.getElementById(`child_live${x}`).value,
      dummyObject[`childName`] = `${props.underAge18.yes.childInfo[x - 1].first_name} ${props.underAge18.yes.childInfo[x - 1].last_name}`,
      dummyObject[`childUiId`] = x,
      dummyObject[`children_id`] = props.underAge18.yes.childInfo[x - 1].children_id,
      dummyObject[`current_address_id`]= !isUndefined(find(props.addressConfidential.yes.childDetails, x=> x.child_name == dummyObject[`childName`])) ? find(props.addressConfidential.yes.childDetails, x=> x.child_name == dummyObject[`childName`]).current_address_id : "",
      dummyObject[`divorce_id`] = window.localStorage.getItem("divorce_id")
    forEach([1, 2, 3], (y, indexy) => {
      let foundByName = find(props.addressConfidential.yes.childDetails, 
        x => x.child_name == dummyObject.childName);
    
      let foundByAddress = find(props.addressConfidential.yes.childDetails, 
        x => x.current_address_id == dummyObject.current_address_id);
      let z = {
        date_from: !isNull(document.getElementById(`${y}datefrom${x}`)) && !isEmpty(document.getElementById(`${y}datefrom${x}`)) ? document.getElementById(`${y}datefrom${x}`).value : "1947-01-01",
        date_to: !isNull(document.getElementById(`${y}dateTo${x}`)) && !isEmpty(document.getElementById(`${y}dateTo${x}`)) ? document.getElementById(`${y}dateTo${x}`).value : "1947-01-01",
        child_address: !isNull(document.getElementById(`${y}child_address${x}`)) ? document.getElementById(`${y}child_address${x}`).value : '',
        child_live_with: !isNull(document.getElementById(`${y}child_live_with${x}`)) ? document.getElementById(`${y}child_live_with${x}`).value : '',
        relationship: !isNull(document.getElementById(`${y}relationship${x}`)) ? document.getElementById(`${y}relationship${x}`).value : '',
        childUiId: x,
        children_residence_id: foundByName && foundByAddress?.childRes?.[y - 1]?.children_residence_id || ""
      }
      childResidenceArray1.push(z);
      
    });

    dummyObject[`childRes`] = childResidenceArray1;
    if (childNumber == 1) setChildDetails1(dummyObject);

    }
    else{
      // if(document.getElementById(`checkboxResidence${x}`).checked){
      // eslint-disable-next-line no-unused-expressions
      console.log(document.getElementById(`date_from${x}`) == null, "document.getElementById(`date_from${x}`) == null"),
      document.getElementById(`address_child${x}`) == null ? dummyObject[`address_child`] = '' : dummyObject[`address_child`] = document.getElementById(`address_child${x}`).value,

      document.getElementById(`date_from${x}`) == null ? dummyObject[`date_from`] = '' : dummyObject[`date_from`] = document.getElementById(`date_from${x}`).value,
      // dummyObject[`date_from`] = document.getElementById(`date_from${x}`).value,

      document.getElementById(`childrelation${x}`) == null ? dummyObject[`childrelation`] = '' : dummyObject[`childrelation`] = document.getElementById(`childrelation${x}`).value,
      // dummyObject[`childrelation`] = document.getElementById(`childrelation${x}`).value,

      document.getElementById(`confidential${x}`) == null ? dummyObject[`confidential`] = '' : dummyObject[`confidential`] = document.getElementById(`confidential${x}`).checked == true ? 1 : 0,
      // dummyObject[`confidential`] = document.getElementById(`confidential${x}`).checked == true ? 1 : 0,

      document.getElementById(`child_live_cond${x}`) == null ? dummyObject[`child_live_cond`] = '' : dummyObject[`child_live_cond`] = document.getElementById(`child_live_cond${x}`).checked == true ? 1 : 0,
      // dummyObject[`child_live_cond`] = document.getElementById(`child_live_cond${x}`).checked == true ? 1 : 0,

      document.getElementById(`child_live${x}`) == null ? dummyObject[`child_live`] = '' : dummyObject[`child_live`] = document.getElementById(`child_live${x}`).value,
      // dummyObject[`child_live`] = document.getElementById(`child_live${x}`).value,

      dummyObject[`childName`] = `${props.underAge18.yes.childInfo[x - 1].first_name} ${props.underAge18.yes.childInfo[x - 1].last_name}`,
      dummyObject[`childUiId`] = x,
      dummyObject[`children_id`] = props.underAge18.yes.childInfo[x - 1].children_id,
      dummyObject[`current_address_id`]= !isUndefined(find(props.addressConfidential.yes.childDetails, x=> x.child_name == dummyObject[`childName`])) ? find(props.addressConfidential.yes.childDetails, x=> x.child_name == dummyObject[`childName`]).current_address_id : "",
      dummyObject[`divorce_id`] = window.localStorage.getItem("divorce_id")
    forEach([1, 2, 3], (y, indexy) => {
      const foundByName = find(props.addressConfidential.yes.childDetails,
        x => x.child_name == dummyObject.childName
      );
    
      const foundByAddress = find(props.addressConfidential.yes.childDetails,
        x => x.current_address_id == dummyObject.current_address_id
      );
      let z = {
        date_from: !isNull(document.getElementById(`${y}datefrom${x}`)) && !isEmpty(document.getElementById(`${y}datefrom${x}`)) ? document.getElementById(`${y}datefrom${x}`).value : '1947-01-01',
        date_to: !isNull(document.getElementById(`${y}dateTo${x}`)) && !isEmpty(document.getElementById(`${y}dateTo${x}`)) ? document.getElementById(`${y}dateTo${x}`).value : '1947-01-01',
        child_address: !isNull(document.getElementById(`${y}child_address${x}`)) ? document.getElementById(`${y}child_address${x}`).value : '',
        child_live_with: !isNull(document.getElementById(`${y}child_live_with${x}`)) ? document.getElementById(`${y}child_live_with${x}`).value : '',
        relationship: !isNull(document.getElementById(`${y}relationship${x}`)) ? document.getElementById(`${y}relationship${x}`).value : '',
        childUiId: x,
        children_residence_id: foundByName && foundByAddress?.childRes?.[y - 1]?.children_residence_id || ""
      }
      console.log(!isUndefined(find(props.addressConfidential.yes.childDetails,
        x=> x.child_name == dummyObject[`childName`])), "childUndefined")
      childResidenceArray1.push(z);
      
    });

    dummyObject[`childRes`] = childResidenceArray1;
     if (childNumber == 2) setChildDetails2(dummyObject);
    else if (childNumber == 3) setChildDetails3(dummyObject);
    else if (childNumber == 4) setChildDetails4(dummyObject);
  // }
  }
  setActiveStepChild((prevActiveStep) => prevActiveStep + 1);
  activeStepChild === childSteps.length - 1  && handleShow();
  };


   function handleNextChild () {
    handlePostChildFunc(activeStepChild + 1)

  };

  const handleBackChild = () => {
    setActiveStepChild((prevActiveStep) => prevActiveStep - 1);
  };

  const handleResetChild = () => {
    setActiveStepChild(0);
  };

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical"
       style={{
fontStyle: "normal",
fontFamily: "sans-serif",
backgroundColor: "white",
textAlign: "justify",
textJustify: "inter-word",
padding: "30px 70px"

}}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <Typography>{getStepContent(index)}</Typography>
              <div className={classes.actionsContainer}>
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  <Button
                    disabled={conditionOfDisabled()}
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} className={classes.button}>
            Reset
          </Button>
          <Button style={{backgroundColor:"#3f51b5",color:"white"}} onClick={handleBack} className={classes.button}>
           Back
          </Button>
        </Paper>
      )}
      <Modal isOpen={show} style={{ marginTop: "200px", marginLeft: "46%" }}>
        <ModalHeader>
        Save Data:
        </ModalHeader>
        <ModalBody> Save child details?
        </ModalBody>
        <ModalFooter>
        <Row style={{marginLeft:"3px"}}>
        <Button
          style={{width:"48%",marginRight:"2px", color: "white", backgroundColor: "Blue" }}
          onClick={()=> {saveChildResDetails(); handleClose()}}
        >
          Save
        </Button>
        </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
}



const mapDispatchToProps = (dispatch) => {
  return {

    putChildAge: (data) => dispatch(putChildAge(data)),
    putChildResidence: (data) => dispatch(putChildResidence(data)),
    getAllData: (data) => dispatch(getAllData(data)),
    deleteChildCall: (data) => dispatch(deleteChildCall(data)),
  };
};

const mapStateToProps = (state, ownProps) => ({
  isFetchingGetAllData: state.ChildInformationReducer.isFetchingGetAllData,
  isFetchingChildAge: state.ChildInformationReducer.isFetchingChildAge,
  isFetchingChildResidence: state.ChildInformationReducer.isFetchingChildResidence,
  underAge18: state.ChildInformationReducer.underAge18,
  addressConfidential: state.ChildInformationReducer.addressConfidential,
  moreThanChildren: state.ChildInformationReducer.moreThanChildren,
  unableUpdateChild: state.ChildInformationReducer.unableUpdateChild,
  unableUpdateChildRes: state.ChildInformationReducer.unableUpdateChildRes,

});

export default connect(mapStateToProps, mapDispatchToProps)(VerticalLinearStepper);